/**
 * Image Service
 * Handles image loading and dimension calculations
 */

export type ImageDimensions = {
  width: number
  height: number
  aspectRatio: number
}

/**
 * Load an image and calculate its dimensions
 */
export const getImageDimensions = (imageUrl: string): Promise<ImageDimensions> => {
  return new Promise((resolve, reject) => {
    const img = new Image()

    img.onload = () => {
      const dimensions: ImageDimensions = {
        width: img.naturalWidth,
        height: img.naturalHeight,
        aspectRatio: img.naturalHeight / img.naturalWidth,
      }
      resolve(dimensions)
    }

    img.onerror = () => {
      reject(new Error(`Failed to load image: ${imageUrl}`))
    }

    // Set crossOrigin for CDN images to enable CORS
    // This is needed for images from cdn.nicelittlethings.be
    if (imageUrl.includes('cdn.nicelittlethings.be')) {
      img.crossOrigin = 'anonymous'
    }

    img.src = imageUrl
  })
}

/**
 * Calculate height in mm based on width and aspect ratio
 */
export const calculateHeightFromWidth = (widthMm: number, aspectRatio: number): number => {
  return widthMm * aspectRatio
}
